import React, { Suspense } from 'react'
import SuspenseContentFallback from './SuspenseContentFallback'

const SuspenseContent: React.FC = ({ children }) => {
  return <Suspense fallback={<SuspenseContentFallback />}>{children}</Suspense>
}

export default SuspenseContent
